<template>
  <section class="block block__dark block__default">
    <img src="@/assets/majoris.svg" alt="Majoris" class="img__logo" ref="majoris" />
    <p class="text__accent mt-25">{{ content.header }}</p>
    <h2 class="h2">{{ content.title }}</h2>
    <div class="flex__paragraph">
      <p class="paragraph w-100">{{ content.text_1 }}</p>
      <p class="paragraph w-100">{{ content.text_2 }}</p>
    </div>
    <DynamicLink :button="content.button" :link="link" :page="page" class="mt-30" />
  </section>
</template>

<script>
import DynamicLink from '@/components/small/DynamicLink.vue'

export default {
  name: 'QuoteSection',
  components: { DynamicLink },
  props: {
    content: {
      type: Object,
      required: true,
    },
    link: {
      type: String,
      default: '',
    },
    page: {
      type: String,
      default: '',
    },
  },
}
</script>
